import { get } from 'lodash';
import moment from 'moment';
var getConsentDateDisplay = function getConsentDateDisplay(contact, consentStatus) {
  var consentedAt = get(contact, 'consent.consented_at', '');
  var updatedAt = get(contact, 'consent.updated_at', '');
  var revokedOn = get(contact, 'consent.revoked_on', '');
  var creationDate = consentedAt ? moment(consentedAt).format('M/D/YYYY') : '';
  var declinedDate = updatedAt ? moment(updatedAt).format('M/D/YYYY') : '';
  var revokedDate = revokedOn ? moment(revokedOn).format('M/D/YYYY') : '';
  switch (consentStatus) {
    case 'accepted':
      return "Received on ".concat(creationDate);
    case 'revoked':
      return "Revoked on ".concat(revokedDate);
    case 'declined':
      return "Declined on ".concat(declinedDate);
    default:
      return '';
  }
  ;
};
export default getConsentDateDisplay;
//# sourceMappingURL=getConsentDateDisplay.js.map